import axios from 'axios'
import * as types from '../mutation-types'

const state = {
  operatorTypes: [],
  legalEntityForms: [],
  regions: [],
  privilegeCategories: [],
  operators: [],
  singleOperator: false,
  currentOperator: null
}

// getters
const getters = {
  operatorTypes: state => state.operatorTypes,
  legalEntityForms: state => state.legalEntityForms,
  regions: state => state.regions,
  privilegeCategories: state => state.privilegeCategories,
  operators: state => state.operators,
  singleOperator: state => state.singleOperator,
  currentOperator: state => state.currentOperator
}

// actions
const actions = {
  async setCurrentOperator ({commit, dispatch}, operator) {
    commit(types.MUTATE_CURRENT_OPERATOR, operator)
    await dispatch('getReports', {
      params: {'operator': operator}
    })
  },
  async init ({commit}) {
    let resp = await axios.get('/api/operator_types/')
    commit(types.MUTATE_OPERATOR_TYPES, resp.data)
    resp = await axios.get('/api/legal_entity_forms/')
    commit(types.MUTATE_LEGAL_ENTITY_FORMS, resp.data)
    resp = await axios.get('/api/regions/')
    commit(types.MUTATE_REGIONS, resp.data)
    resp = await axios.get('/api/privilege_categories/')
    commit(types.MUTATE_PRIVILEGE_CATEGORIES, resp.data)
    resp = await axios.get('/api/operators/')
    commit(types.MUTATE_OPERATORS, resp.data)
  },
  async getOperators ({commit}) {
    let resp = await axios.get('/api/operators/')
    commit(types.MUTATE_OPERATORS, resp.data)
  }
}

// mutations
const mutations = {
  [types.MUTATE_CURRENT_OPERATOR] (state, operator) {
    state.currentOperator = state.operators.find(item => Number(item.id) === Number(operator))
  },
  [types.MUTATE_OPERATOR_TYPES] (state, operatorTypes) {
    state.operatorTypes = operatorTypes
  },
  [types.MUTATE_LEGAL_ENTITY_FORMS] (state, legalEntityForms) {
    state.legalEntityForms = legalEntityForms
  },
  [types.MUTATE_REGIONS] (state, regions) {
    state.regions = regions
  },
  [types.MUTATE_PRIVILEGE_CATEGORIES] (state, privilegeCategories) {
    state.privilegeCategories = privilegeCategories
  },
  [types.MUTATE_OPERATORS] (state, operators) {
    state.operators = operators
    if (operators.length === 1) {
      state.singleOperator = true
    } else {
      state.singleOperator = false
      state.currentOperator = null
    }
    if (!state.currentOperator || state.currentOperator !== operators[0]) {
      state.currentOperator = operators[0]
      // state.singleOperator = false
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dicts.js